// extracted by mini-css-extract-plugin
module.exports = {"base":"LogoMarquee-module-base","logoList":"LogoMarquee-module-logo-list","scrollAnimation":"LogoMarquee-module-scroll-animation","logoItem":"LogoMarquee-module-logo-item"};